import styled from 'styled-components';
import { OrderPanelStyledAC } from '../OrderPanelStyled.AC';

export const OrderPanelStyledACGB = styled(OrderPanelStyledAC)`
    .wrapper
        .section
        .order-panel-price-container
        .content
        .body
        .body-wrapper
        .footer
        .promotionalTextWrapper:first-child {
        display: flex;
        flex-direction: row;
    }

    .wrapper {
        .section {
            border-color: ${({ theme }) => theme.colors.grey26} !important;
            border-width: 1px !important;
        }
    }
`;
